export default __webpack_public_path__ + "static/media/krzyzowka_3_rozw.4c06fa48.jpg";